@if (!hasError) {
  <div #errorContainer></div>
} @else {
  <div class="messageAlert">
    <p>Something went wrong.</p>
    <p>Please contact your administrator.</p>
  </div>
}
